import React, { useCallback } from 'react';

import { FasatDropdown, FasatFormElement, FasatLabel } from '../../../../common/components';
import { globalConstants, staticCommonLabelKeys } from '../../../../common/moduleConstants';
import { getErrorsPage } from '../../../../common/util';
import { getAction } from '../../../../../stateManagement/reduxUtil';
import { lookUpsDataProcessing } from '../../../../common/redux/actions/commonActions';
import { fieldForceActionTypes } from '../../redux';
import { addRules, addRuleConfig } from './addEditDeductionRuleConfig';
import { getReqPayLoad,

} from './addEditDeductionHelper';

const { formElement, formRow, commonFE } = globalConstants;
const formRuleIDs = addRules;
const formRuleConfig = addRuleConfig;
const getProvinceLookUp = (dispatch, locale, val, formik) => {
  const reqnewObj = { transaction: val, transactionMode: 'INSERT', priority: 0 };
  dispatch(getAction(fieldForceActionTypes.GET_FF_TRAN_DETAILS, reqnewObj));
  formik.setFieldValue('adeType', val);
  const tt = getReqPayLoad(locale);
  dispatch(lookUpsDataProcessing(tt));
  if (val !== 'BKRPT') {
    formik.setFieldValue('adeTransAgtCd', null);
    formik.setFieldValue('adeTransAgtName', '');
  }
};
export function AddRow1({ props }) {
  const { t, dispatch, transactonOptions, locale, CurrencyOptions, serverErrors, clientId, formik } = props;
  return (
    <div className={formRow}>
      <div className={`${formElement} ${commonFE}`}>
        <FasatFormElement
          direction="bottom"
          id="adeCurrFrm"
          name="adeCurr"
          errors={getErrorsPage('adeCurr', formik, serverErrors, formRuleIDs.adeCurr, formRuleConfig, false, t)}
        >
          <FasatLabel>{t(staticCommonLabelKeys.COMMON_LABEL_MLC_SELLING_CD)}</FasatLabel>
          <FasatLabel isContent>{clientId}</FasatLabel>
        </FasatFormElement>
      </div>
      <div className={`${formElement} ${commonFE}`}>
        <FasatFormElement
          direction="bottom"
          id="adeTypeForm"
          errors={getErrorsPage('adeType', formik, serverErrors, formRuleIDs.adeType, formRuleConfig, false, t)}
        >
          <FasatDropdown
            dropdownItems={transactonOptions}
            onHandleChange={useCallback((val) => getProvinceLookUp(dispatch, locale, val, formik), [formik, dispatch, locale])}
            id="adeType"
            label={t(staticCommonLabelKeys.COMMON_LABEL_TRANSACTION)}
            name="adeType"
            {...formik.getFieldProps('adeType')}
            selected={0}
            placeholder={t(staticCommonLabelKeys.COMMON_PLACEHOLDER_SELECT)}
            errors={getErrorsPage('adeType', formik, serverErrors, formRuleIDs.adeType, formRuleConfig, true, t)}
            ariaRequired
          />
        </FasatFormElement>
      </div>
      <div className={`${formElement} ${commonFE}`}>
        <FasatFormElement
          direction="bottom"
          id="adeCurrForm"
          name="adeCurr"
          errors={getErrorsPage('adeCurr', formik, serverErrors, formRuleIDs.adeCurr, formRuleConfig, false, t)}
        >
          <FasatLabel>{t(staticCommonLabelKeys.COMMON_LABEL_CURRENCY)}</FasatLabel>
          <FasatLabel isContent>
            {CurrencyOptions && CurrencyOptions.filter((index) => index.value === 'CA')[0]?.label}
          </FasatLabel>
        </FasatFormElement>
      </div>
    </div>
  );
}
